import { render, staticRenderFns } from "./SetupOptions.vue?vue&type=template&id=4cfbfcb7&scoped=true&lang=pug"
import script from "./SetupOptions.vue?vue&type=script&lang=js"
export * from "./SetupOptions.vue?vue&type=script&lang=js"
import style0 from "./SetupOptions.vue?vue&type=style&index=0&id=4cfbfcb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfbfcb7",
  null
  
)

export default component.exports